import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  selected: {
    color: theme.palette.primary.main,
  },
}));

const NavbarListItem = ({ icon, path, title }) => {
  const { pathname } = useLocation();
  const classes = useStyles();

  return (
    <ListItem
      button
      component={NavLink}
      exact
      to={path}
      activeClassName={classes.selected}
    >
      <ListItemIcon className={pathname === path ? classes.selected : ''}>
        {icon}
      </ListItemIcon>
      <ListItemText primary={title} />
    </ListItem>
  );
};

NavbarListItem.propTypes = {
  path: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
};

export default NavbarListItem;
